import React from 'react';
import PropTypes from 'prop-types';

import {
    Grid,
    Link,
    MessageBox,
    MessageBoxText,
} from 'yurstrap';

const propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string,
    ]),
};

const defaultProps = {
    children: [],
};

class GodBuster extends React.Component {

    constructor(props) {
        super(props);
        window.callGodBuster = this.componentDidCatch.bind(this, new Error('Test error'));
        this.state = {
            hasError: false,
        };
    }

    componentDidCatch() {
        this.setState({ hasError: true });
    }

    render() {
        const { hasError } = this.state;
        if (hasError) {
            return (
                <Grid size="small" style={{ marginTop: '60px' }}>
                    <MessageBox type="error" className="mt-4">
                        <MessageBoxText className="u-font-size--4">
                            Une erreur inconnue est survenue.
                            Notre équipe technique a été notifiée de ce problème.
                            <br />
                            Nous nous excusons de la gêne occasionnée.
                            <br />
                            <span className="u-font-size--4">
                                <Link
                                    inline
                                    color="error"
                                    className="u-font-weight--bold"
                                    onClick={() => {
                                        window.location.reload();
                                    }}
                                >
                                    Cliquez ici
                                </Link>
                                {' pour recharger la page'}
                            </span>
                        </MessageBoxText>
                    </MessageBox>
                </Grid>
            );
        }
        const { children } = this.props;
        return children;
    }

}

GodBuster.propTypes = propTypes;
GodBuster.defaultProps = defaultProps;

export default GodBuster;
